(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('IndividualMeterSearch', IndividualMeterSearch);

    IndividualMeterSearch.$inject = ['$resource'];

    function IndividualMeterSearch($resource) {
        var resourceUrl =  'api/individual-meters/search/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
